import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Projects } from "./components/projects";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("dark-mode-body", darkMode);
    document.documentElement.classList.toggle("dark-mode-body", darkMode);
  }, [darkMode]);

  return (
    <div className={darkMode ? "dark-mode" : ""}>
      <Navigation
        darkMode={darkMode}
        toggleDarkMode={() => setDarkMode(!darkMode)}
      />

      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Projects data={landingPageData.Projects} />
    </div>
  );
};



export default App;